import dayjs from "dayjs";
import Swal from "sweetalert2";
import buddhistEra from "dayjs/plugin/buddhistEra";

export const imageFileExtension = ["jpg", "jpeg", "png", "gif", "webp", "svg"];

const AppUtility = {
  AxiosResponseError: function (error) {
    if (error.response) {
      let response = error.response;
      let text = response.data.error_message;
      let redirectUrl = null;

      if (response.status === 401 || response.status === 403) {
        text = "Session หมดอายุ กรุณา Login ใหม่";
        localStorage.clear();
        redirectUrl = "/";
      } else if (response.data.code === "0003") {
        let _data = error.config.data
          ? JSON.parse(error.config.data)
          : { email: "" };
        redirectUrl = `/register?email=${_data.email}`;
      }

      Swal.fire({
        html: `<h4>${text}</h4>`,
        icon: "warning",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed && redirectUrl) {
          window.location.href = redirectUrl;
        }
      });
    }
  },

  displayDatetime(data, has_time = false) {
    dayjs.extend(buddhistEra);
    let format_datetime = "dddd D MMM BBBB";
    if (has_time) {
      format_datetime = "dddd D MMM BBBB HH:mm:ss";
    }
    return dayjs(data).format(format_datetime);
  },

  displayNumber(data, digit = 2) {
    return Number(data)
      .toFixed(digit)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  },

  uuidv4: function () {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
      (
        +c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
      ).toString(16)
    );
  },

  generateRandomPassword: function (length = 10) {
    const validChars =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890!@#$%^&*()";
    let password = "";
    // Loop to generate random characters for the password
    for (let i = 0; i < length; i++) {
      // Pick a random character from validChars
      const randomIndex = Math.floor(Math.random() * validChars.length);
      password += validChars[randomIndex];
    }

    return password;
  },

  formatIsoDate(year, month, day) {
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
      2,
      "0"
    )}T00:00:00+07:00`;
  },

  getFileTypeFromUrl(url) {
    const extension = url.split(".").pop().toLowerCase();
    if (imageFileExtension.includes(extension)) {
      return "image";
    }
    return extension;
  },

  getFileNameFromUrl(url) {
    const spiltExtension = url.split("/");
    const fileName = spiltExtension.pop().split("/").pop();
    return fileName;
  },

  refreshPage() {
    window.location.reload();
  },
};
export default AppUtility;
